/*#__PURE__*/ export default JSON.parse('{"key":"skeleton","type":"root","items":[]}');